<template>
  <div class="flex min-h-screen flex-col">
    <NuxtLayout class="flex flex-1 flex-col" name="default">
      <template #header>
        <MinimalHeader is-always-sticky />
      </template>

      <div class="flex flex-1 flex-col">
        <slot />
      </div>

      <template #footer>
        <!--No footer-->
        {{ null }}
      </template>
    </NuxtLayout>
  </div>
</template>

<script lang="ts" setup>
import MinimalHeader from '@/scopes/navigation/components/MinimalHeader.vue'
</script>
